import { getOrdersCount } from "action/utils/getOrdersCount";
import { checkItemFitmentApi } from "api/shopping-cart/checkItemFitmentApi";
import { saveItemApi } from "api/shopping-cart/saveItemApi";
import getCustomSizeQuery from "util/url/getCustomSizeQuery";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { hideLoader } from "../loader/hideLoader";
import { showLoader } from "../loader/showLoader";
import { openModal } from "../modal/openModal";
import { refreshShoppingCart } from "./refreshShoppingCart";
import { removeSavedItem } from "./removeSavedItem";

function _saveItem(dispatch: any, sku: any, vehicle: any, callback: any) {
  dispatch(showLoader());
  const { customTireSize: customTireSizes, customWheelSize: customWheelSizes } = getCustomSizeQuery();

  saveItemApi(sku, vehicle, { customTireSizes, customWheelSizes })
    .then((response) => {
      dispatch(hideLoader());
      dispatch(refreshShoppingCart(callback));
      dispatch(getOrdersCount());
      if (callback) {
        callback(response.data);
      }
    })
    .catch((err) => {
      dispatch(hideLoader());
      console.log(err);
    });
}

export function saveItem(product: any,
  vehicle = undefined,
  callback = null,
  skipValidation = false,
  quantity = 1) {
  return (dispatch: any, getState: any) => {
    const { sku, description } = product;
    const skipCheckFitment = skipValidation || !validateVehicle(vehicle);
    if (!skipCheckFitment) {
      // If vehicle isn't informed and the selected vehicle is valid
      if (!vehicle) {
        const { selectedVehicle } = getState().garage;
        if (validateVehicle(selectedVehicle)) {
          // eslint-disable-next-line no-param-reassign
          vehicle = { ...selectedVehicle };
        }
      }

      dispatch(showLoader());

      checkItemFitmentApi(sku, vehicle)
        .then(({ data }) => {
          const { fitmentStatus, fitmentOptionsDetails, message } = data;
          const successful = fitmentStatus === "GUARANTEED_FIT";
          dispatch(hideLoader());

          if (successful) {
            if (message === "VEHICLE_NOT_REQUIRED") {
              // eslint-disable-next-line no-param-reassign
              vehicle = undefined;
            }
            _saveItem(dispatch, sku, vehicle, callback);
          } else {
            // IF NEEDS A VEHICLE
            dispatch(
              openModal("checkFitmentModel", {
                title: "Product Fitment Mismatch",
                product,
                sku,
                message,
                description,
                quantity,
                addProductToCart: false,
                // addItem: false,
                callback,
                fitmentOptionsDetails,
                successMessage: {
                  type: "success",
                  message: "This product has been saved into your saved list under shopping cart",
                  title: "Product saved",
                },
              }),
            );
          }
        });
    } else if (quantity === 0) {
      dispatch(removeSavedItem(sku, callback));
    } else {
      _saveItem(dispatch, sku, vehicle, callback);
    }
  };
}
